export default __webpack_public_path__ + "static/media/about-banner.325adead.jpg";